<template>
	<el-tooltip
		:content="content"
	>
		<el-tag
			:class="['mr-5', 'tooltip-tag']"
			:type="type"
			:size="size"
			:closable="closable"
			@click="$emit('click')"
			@close="$emit('close')"
		>
			<span>{{ content }}</span>
		</el-tag>
	</el-tooltip>
</template>

<script>
export default {
	name: 'TooltipTag',
	props: {
		content: {
			type: String,
			required: true
		},
		type: {
			type: String,
			default: 'primary'
		},
		size: {
			type: String,
			default: undefined
		},
		closable: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" scoped>
.tooltip-tag {
	height: fit-content;
	line-height: 1.5em;
	max-width: 220px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: inline-flex;
	align-items: center;

  :deep(span) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0;
    flex-grow: 1;
  }

  :deep(.el-tag__close) {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    margin-top: auto;
  }
}
</style>
